import React, { useEffect, useRef } from 'react';
import { useForm } from 'react-final-form';

import { violationSyncRegistry } from '../helpers/violationSyncRegistry';

interface ISyncedViolationFieldProps {
  children: React.ReactNode;
  violationFieldName: string;
  violationId: string;
}

export const SyncedViolationField = ({ children, violationFieldName, violationId }: ISyncedViolationFieldProps) => {
  const form = useForm();
  const fieldRef = useRef({ form, fieldPath: violationFieldName });

  // Register/unregister
  useEffect(() => {
    if (!violationId) return;
    violationSyncRegistry.register(violationId, fieldRef.current);

    return () => violationSyncRegistry.unregister(violationId, fieldRef.current);
  }, [violationId]);

  return <>{children}</>;
};
